moment.locale('fr')

const employees = {}
const debug = true

/**
 *  @var {HTMLElement}
 */
const $score = document.querySelector('.o-simulateur__score-number')
let step_history = [];
/**
 * Calculate score of an employee.
 *
 * @param {moment} from
 * @param {moment} to
 * @param {Number} rate
 * @returns
 */
const calcEmployeeScore = function (from, to, rate = 100) {
  const fromDay = from.format('D')
  const toDay = to.format('D')

  const fromMonth = from.format('M')
  const toMonth = to.format('M')

  const fromLastDay = from.daysInMonth()
  const toLastDay = to.daysInMonth()

  const fromWorkDays = (fromLastDay - fromDay) + 1
  const toWorkDays = toDay

  const fromRate = (fromWorkDays/fromLastDay) * (rate/100)
  const toRate = (toWorkDays/toLastDay) * (rate/100)

  const nbMonths = toMonth - fromMonth;

  return ((fromRate + toRate + ((nbMonths - 1) * (rate/100)))/*/(nbMonths+1)*/).toFixed(2)
}

/**
 * Calculate score for all employees.
 *
 * @param {Object} employees
 *
 * @returns string
 */
const calcEmployeesScore = function (employees)
{
  let total = 0

  Object.values(employees).forEach(function (v) {
    const res = calcEmployeeScore(v.from, v.to, v.rate)
    total = total + parseFloat(res)
  });
  let occupation = calcEmployeesOccupation(employees)
  if (total) {
    return (total/occupation).toFixed(2)
  }
  return total.toString()
}

/**
 * Calculate occupation months for an employee
 * @param {moment} from
 * @param {moment} to
 * @param {Array} occupation
 * @returns
 */
const calcEmployeeOccupation = function(from, to, occupation){
  const fromMonth = parseInt(from.format('M'))
  const toMonth = parseInt(to.format('M'))
  for(let i = fromMonth; i <= toMonth; i++){
    if(!occupation.includes(i)){
      occupation.push(i)
    }
  }
}

/**
 * Calculate number of occupation months
 * @param {*} employees
 * @returns integer
 */
const calcEmployeesOccupation = function(employees){
  let occupation = []
  Object.values(employees).forEach(function (v){
    calcEmployeeOccupation(v.from, v.to, occupation)
  })
  debug && console.log(occupation)
  return occupation.length
}

/**
 * On change event for an employee form field.
 *
 * @param {HTMLElement} $row
 *
 * @returns void
 */
const changeEmployeeRowInput = function ($row) {
  const index = parseInt($row.dataset.index)
  const $rate = $row.querySelector('.salarie-taux')
  const $from = $row.querySelector('.date-entree')
  const $to = $row.querySelector('.date-sortie')


  if (checkEmployeeRowRate($rate) && checkEmployeeRowDate($from, $to)) {
    const from = moment($from.value)
    const to = moment($to.value)
    employees[index] = {
      from: from,
      to: to,
      rate: parseInt($rate.value)
    }
  } else {
    delete employees[index]
  }

  $score.innerHTML = calcEmployeesScore(employees)
  debug && console.log("score", $score.innerHTML)
}

/**
 * Check employee rate field input.
 *
 * @param {HTMLInputElement} $rate
 *
 * @returns boolean
 */
const checkEmployeeRowRate = function ($rate) {
  return !!$rate.value
}

/**
 * Check employee date fields input.
 *
 * @param {HTMLInputElement} $from
 * @param {HTMLInputElement} $to
 *
 * @returns boolean
 */
 const checkEmployeeRowDate = function ($from, $to) {
  const fromVal = $from.value
  const toVal = $to.value

  if (!fromVal || !toVal) {
    return false
  }

  return moment(toVal).diff(moment(fromVal)) >= 0;
}

const doShowHidePanel = function($panelToShow, $panelToHide) {
  $panelToHide.removeClass('panel-is-shown').addClass('panel-is-hidden');
  setTimeout(function() {
    $panelToHide.hide();
    $panelToShow.removeClass('panel-is-hidden').addClass('panel-is-shown').show();
  }, 500);
}

var fn_simulateur_step = function (clickedElt, panelToShow, panelToHide) {
    var clickedElt = $('' + clickedElt + '');
    var panelToShowElt = $('' + panelToShow + '');

    clickedElt.on('click', function(){
      step_history.push(panelToShow);
      debug && console.log(step_history);
        if (panelToHide) {
            var panelToHideElt = $('' + panelToHide + '');

        } else {
            var panelToHideElt = clickedElt.closest('.o-simulateur__panel');
        }
        doShowHidePanel(panelToShowElt, panelToHideElt)
    });
}

var fn_simulateur = function () {
    if ($('#launch-simulateur').length) {
        fn_simulateur_step("#launch-simulateur", ".o-simulateur__panels, #step-01", ".o-simulateur__home");
        fn_simulateur_step("#simulateur-reset", ".o-simulateur__home", ".o-simulateur__panel.panel-is-shown, .o-simulateur__panels");

        fn_simulateur_step("#step-01-oui", "#step-05");
        fn_simulateur_step("#step-01-non", "#step-negatif");

        fn_simulateur_step("#step-05-oui", "#step-positif");
        fn_simulateur_step("#step-05-non", "#step-02");

        fn_simulateur_step("#step-02-oui", "#step-positif");
        fn_simulateur_step("#step-02-non", "#step-03");

        fn_simulateur_step("#step-03-01", "#step-negatif");
        fn_simulateur_step("#step-03-02", "#step-04-01");
        fn_simulateur_step("#step-03-03", "#step-07");

        fn_simulateur_step("#step-04-01-oui", "#step-04-02");
        fn_simulateur_step("#step-04-01-non", "#step-06");

        fn_simulateur_step("#step-04-02-oui", "#step-positif");
        fn_simulateur_step("#step-04-02-non", "#step-negatif");

        fn_simulateur_step("#step-06-01", "#step-positif");
        fn_simulateur_step("#step-06-02", "#step-negatif");

        // Step "Combien avez-vous eu de salariés sur l’année ?"
        let $s7Nb = $('#step-07-nb')

        $('#step-07-remove').on('click', function(){
            if ($s7Nb.val() > 0) {
              $s7Nb.val( +$('#step-07-nb').val() - 1 );
            }
        });
        $('#step-07-add').on('click', function(){
          $s7Nb.val( +$s7Nb.val() + 1 );
        });

        fn_simulateur_step("#step-07-submit-nb", "#step-07-02")

        $('#step-07-submit-nb').on('click', function(){
            let nbSalaries = $('#step-07-nb').val()
            let $simuTableBody = $('.o-simulateur__table tbody')

            $simuTableBody.empty()

            let currentYear = new Date().getFullYear();
            let lastYear = currentYear -1;
            let firstDay = lastYear+'-01-01';
            let lastDay = lastYear+'-12-31';

            for (let i = 1; i <= nbSalaries; i++) {
                let tableRow = `<tr class="salarie-ligne-${i}" data-index="${i}">
                    <th>Salarié ${i}</th>
                    <td>
                        <label for="salarie-taux-${i}" class="sr-only">Taux de temps de travail, Salarié ${i}</label>
                        <input type="number" class="form-control salarie-taux" id="salarie-taux-${i}" placeholder="%" min="0" max="100">
                    </td>
                    <td>
                        <label for="salarie-date-entree-${i}" class="sr-only">Date d'entrée, Salarié ${i}</label>
                        <input type="date" value='${firstDay}' class="form-control date-entree" id="salarie-date-entree-${i}">
                    </td>
                    <td>
                        <label for="salarie-date-sortie-${i}" class="sr-only">Date de sortie, Salarié ${i}</label>
                        <input type="date" value='${lastDay}' class="form-control date-sortie" id="salarie-date-sortie-${i}" >
                    </td>
                </tr>`

              $simuTableBody.append(tableRow);
            }

            $('input.salarie-taux').on('change', function(e) {
              changeEmployeeRowInput(e.target.closest('tr'))
            });

            $('input.date-entree').on('change', function(e) {
              changeEmployeeRowInput(e.target.closest('tr'))
            });

            $('input.date-sortie').on('change', function(e) {
              changeEmployeeRowInput(e.target.closest('tr'))
            });
        });

        $('#vefifier-eligibilite').on('click', function(e){
          e.preventDefault();
          var panelToHideElt = $("#step-07-02");

         if(parseInt($score.innerHTML.toString()) < 1) {
            var panelToShow = "#step-negatif";
          } else {
            var panelToShow = "#step-positif";
          }
          var panelToShowElt = $(panelToShow)
          step_history.push(panelToShow);
          doShowHidePanel(panelToShowElt, panelToHideElt)
        });

        $('#simulateur-back').on('click', function(e){
          e.preventDefault();

          if(step_history.length > 2){
            var panelToHide = step_history.pop();
            var panelToShow = step_history.at(-1);
            var panelToHideElt = $(panelToHide);
            var panelToShowElt = $(panelToShow);

            debug && console.log("hide & show",panelToHide, panelToShow);

              doShowHidePanel(panelToShowElt, panelToHideElt);


          }else{
            step_history = [];
            $("#simulateur-reset").click();
          }
          debug && console.log(step_history);
        });
    }
}